import React from 'react';
import styled from 'styled-components';
import { ContentLayoutProps } from '..';
import { BaseModal } from '../../components/DesignSystem';
import ErrorBoundary from '../../components/ErrorBoundary';
import { AppProvider } from '../../store/store';
import { Step } from '../../utils/Steps';
import { HeaderContainer } from '../HeaderContainer';
import { NavContainer } from '../NavContainer/NavContainer';

const AppContainer = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--colors-background);
  overflow: hidden;
  base-modal {
    z-index: 9999;
    --window-width: 768px;
  }
`;
const Left = styled.div`
  display: none;
  position: initial;
  overflow: hidden;
  margin-right: 48px;
  // desktop or larger
  @media (min-width: 1024px) {
    display: flex;
  }
  @media (min-width: 1280px) {
    margin-right: 120px;
  }
`;
const Right = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`;
const Top = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  z-index: 1337;
  top: 0px;
  background: var(--colors-background);
  // desktop or larger
  @media (min-width: 1024px) {
    display: none;
  }
`;

interface BottomProps {
  currentStep: string;
}
const Bottom = styled.div<BottomProps>`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: initial;
  // desktop or larger
  @media (min-width: 1024px) {
    margin-top: 40px;
  }
  //tablet and not desktop
  @media (min-width: 496px) and (max-width: 1024px) {
    align-self: center;
  }
  //tablet or larger
  @media (min-width: 496px) {
    width:  ${(props) => (props.currentStep !== 'reponse' ? '496px' : '55%')};
  }
  }
`;
interface AppLayoutProps {
  content: React.ReactElement;
  contentLayout: React.FunctionComponent<ContentLayoutProps>;
  step: Step;
}
export const AppLayout: React.FunctionComponent<AppLayoutProps> = ({ contentLayout: ContentLayout, content, step }) => {
  return (
    <>
      <AppProvider>
        <AppContainer>
          <base-ds-guidelines></base-ds-guidelines>
          <BaseModal></BaseModal>
          <Left>
            <NavContainer currentStep={step} />
          </Left>
          <Right>
            <Top>
              <HeaderContainer currentStep={step} />
            </Top>
            <Bottom currentStep={step}>
              <ErrorBoundary>
                <ContentLayout content={content} currentStep={step} />
              </ErrorBoundary>
            </Bottom>
          </Right>
        </AppContainer>
      </AppProvider>
    </>
  );
};
